module.exports = __webpack_public_path__ + "static/media/arrow-back-white.6560ba1f.svg";